/** Funciones para facilitar el manejo de Arrays */
export class ArrayHelper {

    /** Lista los elementos seleccionados removiendo registros repetidos. */
    static distinct<TItem, TResult>(items: TItem[], selector: (item: TItem) => TResult ) : TResult[] {
        const newItems = items.map(selector);
        return [...new Set(newItems)];
    }
}